import CodeMirror from '@uiw/react-codemirror'
import { json } from '@codemirror/lang-json'
import { createTheme } from '@uiw/codemirror-themes'

const theme = createTheme({
  theme: 'light',
  settings: {
    background: '#f1f5f9',
    foreground: '#48566a',
    selectionMatch: '#5eead4',
    gutterBackground: '#f1f5f9',
    selection: '#ccfbf1',
  },
  styles: [],
})

const basicSetup = {
  searchKeymap: true,
}

type Props = {
  content: string
  onChange: (value: string) => void
}

export default function Editor(props: Props) {
  return (
    <CodeMirror
      color="#000"
      height="auto"
      value={props.content}
      basicSetup={basicSetup}
      theme={theme}
      extensions={[json()]}
      onChange={props.onChange}
    />
  )
}
